import { render, staticRenderFns } from "./BillDetail.vue?vue&type=template&id=7494efca&scoped=true&"
import script from "./BillDetail.vue?vue&type=script&lang=js&"
export * from "./BillDetail.vue?vue&type=script&lang=js&"
import style0 from "./BillDetail.vue?vue&type=style&index=0&id=7494efca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7494efca",
  null
  
)

export default component.exports